import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Same three environments as web-v2, chosen by VITE_ENVIRONMENT.
export function getApiUrl(): string {
  switch (import.meta.env.VITE_ENVIRONMENT) {
    case 'production':
      return 'https://api.handly.de'
    case 'local':
      return 'http://localhost:3000'
    default:
      return 'https://dev.api.handly.de'
  }
}
